/**
 * Chess Arenas API – same backend as chess-arenas app (nest-brc ChessArenasModule).
 * Used when a BRC chess room has tournament type "arena" and an arenaId.
 */
import http from './api'

export interface Arena {
  id: string
  name: string
  description?: string
  isPublic?: boolean
  logo?: string
  banner?: string
  accentColor?: string
  primaryColor?: string
  secondaryColor?: string
  defaultTimeControl?: string
  pointsForWin?: number
  pointsForDraw?: number
  pointsForLoss?: number
  seatPolicy?: string
  waitlistMode?: string
  createdBy?: string
  createdAt?: string
  updatedAt?: string
}

class ChessArenasService {
  async getArena(arenaId: string): Promise<Arena> {
    const response = await http.get(`/chess-arenas/${arenaId}`)
    return response.data?.arena ?? response.data
  }

  async joinArena(arenaId: string): Promise<void> {
    await http.post(`/chess-arenas/${arenaId}/join`)
  }

  async leaveArena(arenaId: string): Promise<void> {
    await http.post(`/chess-arenas/${arenaId}/leave`)
  }

  async getArenaGames(arenaId: string): Promise<any[]> {
    const response = await http.get(`/chess-arenas/${arenaId}/games`)
    return response.data?.games ?? response.data ?? []
  }

  async getArenaLeaderboard(arenaId: string): Promise<any[]> {
    const response = await http.get(`/chess-arenas/${arenaId}/leaderboard`)
    return response.data?.leaderboard ?? response.data ?? []
  }

  async getArenaPlayers(arenaId: string): Promise<any[]> {
    const response = await http.get(`/chess-arenas/${arenaId}/players`)
    return response.data?.players ?? response.data ?? []
  }

  async getArenaGame(arenaId: string, gameId: string): Promise<any> {
    const response = await http.get(`/chess-arenas/${arenaId}/games/${gameId}`)
    return response.data?.game ?? response.data
  }

  /** Room owner or arena creator (see nest ChessArenasService.update). */
  async updateArena(arenaId: string, body: Partial<Arena>): Promise<Arena> {
    const response = await http.patch(`/chess-arenas/${arenaId}`, body)
    return response.data?.arena ?? response.data
  }
}

const chessArenasService = new ChessArenasService()
export default chessArenasService
